import React, { useState, useEffect } from "react";
import BuyerOverview from "./BuyerOverview";
import BuyerRFQs from "./BuyerRFQs";
import BuyerSavedProducts from "./BuyerSavedProducts";
import BuyerProfile from "./BuyerProfile";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Tooltip } from "reactstrap";

const BuyerDashboard = () => {
  const [tab, setTab] = useState("overview");
  const { user } = useAuth();
  const [showProfile, setShowProfile] = useState(false);
  const [tooltips, setTooltips] = useState({
    backProducts: false,
    viewProfile: false,
    overviewTab: false,
    rfqsTab: false,
    savedTab: false
  });

  const toggleTooltip = (tooltipName) => {
    setTooltips(prev => ({
      ...prev,
      [tooltipName]: !prev[tooltipName]
    }));
  };
  const profile = user || {};

  const navigate = useNavigate();

  const renderTab = () => {
    if (tab === "overview") return <BuyerOverview />;
    if (tab === "rfqs") return <BuyerRFQs />;
    if (tab === "saved") return <BuyerSavedProducts />;
  };

  const getTabStyle = (isActive) => ({
    padding: "8px 24px",
    fontSize: "clamp(12px, 1.2vw, 13px)",
    fontWeight: "600",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    backgroundColor: isActive ? "#ffffff" : "transparent",
    color: isActive ? "#112347" : "#6b7280",
    boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
    transition: "all 0.2s",
    whiteSpace: "nowrap" // Prevents tabs from breaking on small screens
  });

  return (
    <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh", padding: "clamp(15px, 4vw, 40px)" }}>
      {showProfile ? (
        <BuyerProfile onBack={() => setShowProfile(false)} />
      ) : (
        <>
          {/* HEADER SECTION */}
          <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4 mb-md-5">
            <div>
              <h2 className="fw-bold" style={{ color: "#112347", margin: 0, fontSize: "clamp(20px, 3vw, 28px)" }}>
                Welcome, {profile.name || "Buyer"}
              </h2>
              <p className="text-muted mt-1" style={{ fontSize: "clamp(13px, 1.5vw, 16px)" }}>
                Manage your inquiries, RFQs and product searches
              </p>
            </div>

            <div className="d-flex flex-wrap gap-2">
              {/* BACK TO LANDING */}
              <button
                id="backProductsBtn"
                className="btn btn-outline-dark text-nowrap"
                onClick={() => navigate("/")}
              >
                ← Back to Products
              </button>
              <Tooltip placement="bottom" isOpen={tooltips.backProducts} target="backProductsBtn" toggle={() => toggleTooltip('backProducts')}>
                Return to product browsing
              </Tooltip>

              {/* PROFILE */}
              <button
                id="viewProfileBtn"
                className="btn btn-dark fw-bold text-nowrap"
                style={{ padding: "10px 20px" }}
                onClick={() => setShowProfile(true)}
              >
                View Profile
              </button>
              <Tooltip placement="bottom" isOpen={tooltips.viewProfile} target="viewProfileBtn" toggle={() => toggleTooltip('viewProfile')}>
                Edit your buyer profile
              </Tooltip>
            </div>
          </div>

          {/* PILL NAVIGATION (Includes Overview now) */}
          <div 
            className="d-flex gap-2 p-2 mb-4" 
            style={{ 
              backgroundColor: "#f3f4f6", 
              borderRadius: "10px", 
              width: "100%", 
              maxWidth: "max-content",
              overflowX: "auto", 
              WebkitOverflowScrolling: "touch" 
            }}
          >
            <button id="overviewTab" style={getTabStyle(tab === "overview")} onClick={() => setTab("overview")}>Overview</button>
            <Tooltip placement="bottom" isOpen={tooltips.overviewTab} target="overviewTab" toggle={() => toggleTooltip('overviewTab')}>
              View your buying activity overview
            </Tooltip>
            <button id="rfqsTab" style={getTabStyle(tab === "rfqs")} onClick={() => setTab("rfqs")}>RFQs</button>
            <Tooltip placement="bottom" isOpen={tooltips.rfqsTab} target="rfqsTab" toggle={() => toggleTooltip('rfqsTab')}>
              View your quotation requests
            </Tooltip>
            <button id="savedTab" style={getTabStyle(tab === "saved")} onClick={() => setTab("saved")}>Saved Products</button>
            <Tooltip placement="bottom" isOpen={tooltips.savedTab} target="savedTab" toggle={() => toggleTooltip('savedTab')}>
              View your saved products
            </Tooltip>
            {/* <button style={getTabStyle(tab === "products")} onClick={() => setTab("products")}>Browse Products</button> */}
          </div>

          {/* DYNAMIC CONTENT AREA */}
          <div className="mt-4">
            {renderTab()}
          </div>
        </>
      )}
    </div>
  );
};

export default BuyerDashboard;